import { FunctionComponent } from "react";

import dynamic from "next/dynamic";

import { EmailEditorProps } from "./EmailEditorSsr";

export { EmailLoader } from "./EmailEditorSsr";

// Disabled SSR to avoid memory leak caused by makeStyles
export const EmailEditor = dynamic(() => import("./EmailEditorSsr").then((mod) => mod.EmailEditorSsr), {
  ssr: false,
}) as FunctionComponent<React.PropsWithChildren<EmailEditorProps>>;
